import { render } from "./futuresAccount.vue?vue&type=template&id=2f187fac&scoped=true"
import script from "./futuresAccount.vue?vue&type=script&lang=js"
export * from "./futuresAccount.vue?vue&type=script&lang=js"

import "./futuresAccount.vue?vue&type=style&index=0&id=2f187fac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f187fac"]])

export default __exports__